import { render, staticRenderFns } from "./TeamsItem.vue?vue&type=template&id=30a13488"
import script from "./TeamsItem.vue?vue&type=script&lang=js"
export * from "./TeamsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports